import styled from "@emotion/styled";
import {mq} from "@styles/helpers";
import {Devices} from "@styles/tokens";

export const QRButton = styled.div`
    position: absolute;
    background-color: #bbbbbbb9;
    padding:8px;
    top: 10%;
    right:10%;
    color:#fff;
    height:80%;
    aspect-ratio: 1 / 1;
    display:flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s ease-in-out;
    z-index: 4;
    border-radius: 50%;

    svg{
        height:80%;
    }

    ${mq(Devices.mobile)} {
        right:10px;
    }
`;

export const ToolTip_c = styled.div<{left:string, top:string}>`
    position: absolute;
    top:${props => props.top} !important;
    left:${props => props.left} !important;
`;

export const ModalContent = styled.div`
    background:#fff;
    box-shadow: 0 0 10px 4px rgba(0,0,0,0.25);
    border-radius: 10px;
    padding:20px;
    max-width: 400px;
    h1{
        font-size: 28px;
        font-weight: 600;
    }
    p{
        margin-top: 20px;
        font-size: 16px;
    }
`;

export const HalfContent = styled.div`
    margin-top:-20px;
`;

